module.exports = __webpack_public_path__ + "assets/img/service-7e8b0015.png";